<div class="flex flex-col h-full bg-white overflow-hidden">
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex flex-col p-5 gap-8 overflow-y-auto">
      <button type="button" (click)="goBack()"
        class="bg-white self-start border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors">
        <app-svg class="fg-gris-1 shrink-0" height="20" svgPath="assets/svg/arrow-back.svg" width="20" />
        {{ 'common.back' | translate }}
      </button>

      <p class="fg-noir-2 text-[24px] font-semibold text-center">
        {{ 'choose_instance.title' | translate }}
      </p>

      @if (isLoading()) {
        <div class="flex-1 flex items-center justify-center">
          <p class="fg-gris-1 text-[16px]">{{ 'common.loading' | translate }}</p>
        </div>
      } @else if (!terminals().length) {
        <div class="flex-1 flex items-center justify-center">
          <p class="fg-gris-1 text-[16px]">{{ 'choose_instance.empty' | translate }}</p>
        </div>
      } @else {
        <div class="grid grid-cols-2 gap-5 max-w-[1150px] w-full mx-auto">
          @for (terminal of terminals(); track terminal.id) {
            <div class="bg-white rounded-[5px] h-[98px] flex items-center px-[30px] gap-5">
              <span class="fg-noir-2 text-[18px] font-semibold flex-1 min-w-0 truncate">
                {{ getInstanceLabel(terminal) }}
              </span>
              <button type="button" (click)="selectTerminal(terminal)"
                class="bg-vert-1 border border-gris-4 rounded-[5px] h-[58px] px-5 text-white text-[16px] font-semibold whitespace-nowrap shrink-0 cursor-pointer hover:brightness-95 transition-all">
                {{ 'common.select' | translate }}
              </button>
            </div>
          }
        </div>
      }
    </div>
  </main>
</div>
